<template>
  <div class="home-header">
    <div class="search" @click="search">
      <img src="../../assets/home/home_header-search.png" alt="">
      <span>请输入您想要搜索的内容</span>
    </div>
    <div class="user" @click="$router.push({path: '/user/content'})">
      <img src="../../assets/home/home_header_user.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeHeader",
  methods: {
    search() {
      this.$router.push({path: '/search'})
    }
  }
}
</script>

<style lang="scss" scoped>
.home-header {
  display: flex;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 20px 25px;
  align-items: center;
  justify-content: space-between;
  .search {
    height: 70px;
    width: 627px;
    background: #F5F6F7;
    border-radius: 32px;
    display: flex;
    align-items: center;
    img {
      width: 48px;
      height: 48px;
      margin-left: 23px;
    }
    span {
      margin-left: 17px;
      color: #B2B2B2;
      font-size: 30px;
    }
  }
  .user {
    img {
      width: 48px;
      height: 48px;
    }
  }
}
</style>
